<div class="chips" *ngIf="items.length && showSwiper">
  <swiper [config]="swiperOpt">
    <ng-template *ngFor="let item of items; index as i" swiperSlide>
      <app-chips-item [name]="item.name" [url]="item.url"></app-chips-item>
    </ng-template>
  </swiper>
</div>
<div class="chips" *ngIf="!(items.length && showSwiper)" [style.minHeight.px]="minHeight"></div>